import script from "./MallCheckoutPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallCheckoutPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallCheckoutPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__